import { useState, useEffect } from 'react';
import {Config} from "../config/config";

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
}

export default function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState({dimensions: getWindowDimensions(), isMobile: getWindowDimensions().width < Config.mobileWidth});

    useEffect(() => {
        function handleResize() {
            setWindowDimensions({dimensions: getWindowDimensions(), isMobile: getWindowDimensions().width < Config.mobileWidth});
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
}
